import { isVideoSeason } from "~/components/blocks/product/type-guard";
import { HEAD_PROPERTY_TEMPLATE } from "~/components/blocks/vod/top/const";
import { buildDetailHeadData } from "~/components/templates/vod/detail/head/utils/build-detail-head-data";
import { PAGE_TITLE_SUFFIX } from "~/const/meta";
import type { G_GetVideoQuery } from "~/lib/graphql";

const DEFAULT = {
  pageTitle: HEAD_PROPERTY_TEMPLATE.VOD_TOP.TITLE,
  pageDescription: HEAD_PROPERTY_TEMPLATE.VOD_TOP.DESCRIPTION,
  pageCanonicalUrl: "",
  ogpTitle: "",
  ogpDescription: "",
  ogpUrl: "",
  ogpImage: {
    url: "https://imgsrc.dmm.com/dig/dmmtv/etc/ogp/dmmtvOgp.jpg",
    width: 1200,
    height: 630,
  },
  canonicalUrl: "",
  jsonLd: undefined,
  detailTvJsonLd: undefined,
  detailBreadJsonLd: undefined,
  isNoIndex: false,
};

type Args = {
  video?: G_GetVideoQuery["video"];
  content: string;
  spot?: "true";
};

export const buildVodDetailHeadParams = (args: Args) => {
  const { video, content, spot } = args;

  if (video === undefined) {
    return {
      ...DEFAULT,
    };
  }

  const { titleName, seasonName, metaDescription } = video;
  const title = titleName === seasonName ? titleName : `${titleName} ${seasonName}`;
  const pageTitle =
    content && isVideoSeason(video)
      ? `${title} ${video.episode?.episodeTitle}${PAGE_TITLE_SUFFIX}`
      : `${title}${PAGE_TITLE_SUFFIX}`;
  const {
    ogpTitle,
    ogpDescription,
    ogpDetailUrl,
    ogpImage,
    canonicalDetailUrl,
    detailTvJsonLdData,
    detailBreadcrumbJsonLdData,
  } = buildDetailHeadData({ videoData: video, spot });

  return {
    ...DEFAULT,
    pageTitle,
    pageDescription: metaDescription,
    ogpTitle,
    ogpDescription,
    ogpUrl: ogpDetailUrl,
    ogpImage,
    canonicalUrl: canonicalDetailUrl,
    detailTvJsonLd: detailTvJsonLdData,
    detailBreadJsonLd: detailBreadcrumbJsonLdData,
  };
};
